export var IconName;
(function (IconName) {
    IconName["LOCATION"] = "location";
    IconName["BAN"] = "ban";
    IconName["BRIEFCASE"] = "briefcase";
    IconName["BUSINESS"] = "business";
    IconName["CALENDAR"] = "calendar";
    IconName["MULTIPLY"] = "multiply";
    IconName["REMOVE"] = "remove";
    IconName["USERS"] = "users";
    IconName["CHECK"] = "check";
    IconName["SPINNER"] = "spinner";
    IconName["ADD"] = "add";
    IconName["BILLS"] = "bills";
    IconName["VERIFIED_FILL"] = "verified-fill";
    IconName["SITEMAP"] = "sitemap";
    IconName["SLIDERS"] = "sliders";
    IconName["SHIELD"] = "shield";
    IconName["CARET_DOWN"] = "caret-down-fill";
    IconName["CIRCLE_QUESTION"] = "circle-question";
    IconName["CHEVRON_DOWN"] = "chevron-down";
    IconName["TRASH"] = "trash";
    IconName["SHIELD_CHECK"] = "shield-check";
    IconName["RECEIPT"] = "receipt";
    IconName["LINKEDIN"] = "linkedin";
    IconName["EMAIL"] = "email";
    IconName["CALL"] = "call";
    IconName["SWITCH"] = "switch";
    IconName["CALENDAR_CHECK"] = "calendar-check";
    IconName["USER"] = "user";
    IconName["LINK"] = "link";
    IconName["WARNING"] = "warning";
    IconName["MESSAGE"] = "message";
    IconName["THUMBS_DOWN"] = "thumbs-down";
    IconName["THUMBS_UP"] = "thumbs-up";
    IconName["LIGHTBULB"] = "lightbulb";
    IconName["ARROW_UP"] = "arrow-up";
    IconName["ARROW_DOWN"] = "arrow-down";
    IconName["FAVORITE"] = "favorite";
    IconName["ARROW_LEAVE"] = "arrow-leave";
    IconName["CHEVRON_LEFT"] = "chevron-left";
    IconName["CHEVRON_RIGHT"] = "chevron-right";
    IconName["CONTACT_BOOK"] = "contact-book";
    IconName["HEART"] = "heart";
    IconName["CLOCK"] = "clock";
    IconName["ARROW_LEFT"] = "arrow-left";
    IconName["BARS"] = "bars";
    IconName["DOWNLOAD"] = "download";
    IconName["CHECKLIST"] = "checklist";
    IconName["USER_CHECK"] = "user-check";
    IconName["SHARE"] = "share";
})(IconName || (IconName = {}));
export var IconColor;
(function (IconColor) {
    IconColor["NEUTRAL"] = "neutral";
    IconColor["PRIMARY"] = "primary";
    IconColor["SECONDARY"] = "secondary";
    IconColor["SUCCESS"] = "success";
    IconColor["WARNING"] = "warning";
    IconColor["DANGER"] = "danger";
    IconColor["RED"] = "red";
    IconColor["GREEN"] = "green";
    IconColor["YELLOW"] = "yellow";
    IconColor["LIME"] = "lime";
    IconColor["ORANGE"] = "orange";
})(IconColor || (IconColor = {}));
